import { Link } from 'react-router-dom';
import { Template } from '../Template';
import { questions } from './constants';
import './FAQ.css';

export const FAQ = () => <Template><section className="main-container">
  <span className="eyebrow">A LITTLE MORE CLARITY</span><h1>Glad you asked.</h1><p className="page-description">Get to know Slick, from the technology underneath to what's coming next.</p>
  <div className="faq-list">{questions.map((question, index) => <details className="faq-item" key={question.question}><summary><span className="faq-number">{String(index + 1).padStart(2, '0')}</span><span>{question.question}</span><span className="faq-indicator" aria-hidden="true">+</span></summary><p>{question.answer}</p></details>)}</div>
  <p className="faq-help">Still curious? <Link to="/contact">Get in touch ↗</Link></p>
</section></Template>;
